import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { ISuggestedAllocations } from '../type';

interface ICurrentAllocationProjects {
  currentAllocationProjects: ISuggestedAllocations[];
}

interface ProjectData {
  project: string;
  currentAllocation: string;
  suggestedAllocation: string;
  colorCode: string;
}

function createData(
  project: string,
  currentAllocation: string,
  suggestedAllocation: string,
  colorCode: string
): ProjectData {
  return { project, currentAllocation, suggestedAllocation, colorCode };
}

const AllocationTableInPendingAction = ({
  currentAllocationProjects
}: ICurrentAllocationProjects): JSX.Element => {
  const rows = currentAllocationProjects.map((project) =>
    createData(
      project.projectName,
      project.currentAllocation,
      project.suggestedAllocation,
      project.colorCode
    )
  );

  return (
    <Box
      sx={{
        borderRadius: '20px',
        background: '#ffffff',
        paddingBottom: '10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 'none'
        }}
      >
        <Table
          sx={{
            '& thead th': {
              borderBottom: '2px solid #e0e0e0'
            },
            '& td, & th': {
              borderBottom: 'none',
              padding: '8px',
              fontFamily: 'inherit',
              fontSize: 'inherit',
              color: 'inherit',
              background: 'inherit'
            }
          }}
          size="small"
          aria-label="a simple table"
        >
          <TableHead
            sx={{
              color: '#74777F',
              fontFamily: 'Be Vietnam Pro',
              letterSpacing: '0.25px',
              fontSize: '14px'
            }}
          >
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  fontWeight: 400,
                  minWidth: {
                    xs: '70px',
                    sm: '120px',
                    md: '200px',
                    lg: '250px'
                  }
                }}
              >
                Project
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  fontWeight: 400,
                  minWidth: { xs: '70px', sm: '80px', md: '100px', lg: '200px' }
                }}
              >
                Current Allocation
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  fontWeight: 400,
                  minWidth: { xs: '70px', sm: '80px', md: '100px', lg: '170px' }
                }}
              >
                Suggested Allocation
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              color: '#1A1B1F',
              fontFamily: 'Be Vietnam Pro',
              letterSpacing: '0.5px',
              fontSize: '16px'
            }}
          >
            {rows.map((row) => (
              <TableRow key={row.project}>
                <TableCell component="th" scope="row">
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '15px'
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: '50%',
                        width: '22px',
                        height: '22px',
                        background: row.colorCode
                      }}
                    />
                    {row.project}
                  </Box>
                </TableCell>
                <TableCell align="left">
                  {row.currentAllocation}hours per week
                </TableCell>
                <TableCell align="left">
                  {row.suggestedAllocation}hours per week
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AllocationTableInPendingAction;
